import type { WidgetConfig, InitOptions, WidgetTheme, Locale } from "../types";

const DEFAULT_THEME: Record<Locale, Omit<WidgetTheme, "locale">> = {
  "zh-CN": { primaryColor: "#533afd", position: "bottom-right", title: "联系客服", welcomeText: "One Call, Global Talk · AI 实时翻译" },
  "en-US": { primaryColor: "#533afd", position: "bottom-right", title: "Contact Us", welcomeText: "One Call, Global Talk · AI Translation" },
};

function mergeTheme(remote?: Partial<WidgetTheme>, locale: Locale = "zh-CN"): WidgetTheme {
  const base = DEFAULT_THEME[locale] || DEFAULT_THEME["zh-CN"];
  return { primaryColor: remote?.primaryColor || base.primaryColor, position: remote?.position || base.position, locale: remote?.locale || locale, title: remote?.title || base.title, welcomeText: remote?.welcomeText || base.welcomeText };
}

async function fetchWidgetConfig(apiBase: string, widgetId: string): Promise<WidgetConfig> {
  const base = apiBase.replace(/\/+$/, "");
  const url = `${base}/widget/${encodeURIComponent(widgetId)}/config`;
  const res = await fetch(url, { headers: { Accept: "application/json" } });
  if (!res.ok) throw new Error(`Failed to fetch widget config: ${res.status}`);
  return (await res.json()) as WidgetConfig;
}

function defaultConfig(widgetId: string): WidgetConfig {
  return {
    widgetId,
    features: ["callback", "text_chat"],
    theme: DEFAULT_THEME["zh-CN"] as WidgetTheme,
    imChannels: [],
    voiceFallbackToCallback: true,
  };
}

export async function loadConfig(opts: InitOptions, apiBase?: string): Promise<WidgetConfig> {
  try {
    const remote = await fetchWidgetConfig(apiBase || opts.apiBase || "/api", opts.widgetId);
    return {
      widgetId: remote.widgetId || opts.widgetId,
      features: remote.features || ["callback"],
      theme: mergeTheme(remote.theme, remote.theme?.locale || "zh-CN"),
      imChannels: remote.imChannels || [],
      voiceFallbackToCallback: remote.voiceFallbackToCallback ?? true,
      receptionistId: (remote as any).receptionistId || undefined,
      receptionistName: (remote as any).receptionistName || null,
      textChatWelcome: (remote as any).textChatWelcome || "",
      buttonLogo: (remote as any).buttonLogo || "",
      aiAvatar: (remote as any).aiAvatar || "",
      quickReplies: (remote as any).quickReplies || [],
    };
  } catch (err) {
    if (opts.debug) console.warn("[OneCallSDK] 无法获取远程配置，使用默认配置:", err);
    return defaultConfig(opts.widgetId);
  }
}
